import { deleteApi, getApi, postApi } from "./general.service";

// Hilos de soporte user ↔ equipo (feedback/bugs como chat). Backend:
// core/messaging/conversation en boost-api-v3. Sustituye al apaño de responder
// feedback creando campañas con segment.userIds=[uno].

export const listConversations = async (status) => {
  const qs = status ? `?status=${status}` : "";
  return getApi(`/backoffice/conversations${qs}`);
};

export const getConversation = async (id) => {
  return getApi(`/backoffice/conversations/${id}`);
};

export const getUnreadConversationsCount = async () => {
  return getApi("/backoffice/conversations/unread-count");
};

// Respuesta del equipo: se guarda en el hilo y notifica al usuario por push.
export const replyConversation = async (id, text) => {
  return postApi(`/backoffice/conversations/${id}/messages`, { text });
};

export const markConversationRead = async (id) => {
  return postApi(`/backoffice/conversations/${id}/read`, {});
};

export const closeConversation = async (id) => {
  return postApi(`/backoffice/conversations/${id}/close`, {});
};

// Borrado DEFINITIVO (no el del usuario, que solo lo esconde en su app).
export const deleteConversation = async (id) => {
  return deleteApi(`/backoffice/conversations/${id}`, {});
};

// Devuelve el hilo de un feedback/bug (creándolo si falta) SIN publicar mensaje:
// el botón "Responder" navega con esto directamente al chat de Conversaciones.
export const ensureConversationForSource = async ({ userId, source, sourceId, originalText }) => {
  return postApi("/backoffice/conversations/ensure-source", {
    userId,
    source,
    sourceId,
    originalText,
  });
};

// Responde al hilo de un feedback/bug concreto (lo crea si aún no existía).
// Es lo que usan los botones "Responder" de Feedback y BugsReports.
export const replyToSource = async ({ userId, source, sourceId, text, originalText }) => {
  return postApi("/backoffice/conversations/reply-to-source", {
    userId,
    source,
    sourceId,
    text,
    originalText,
  });
};
